(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('reduce-motion');
    return;
  }

  var supportsTimeline = CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()');
  document.documentElement.classList.add(supportsTimeline ? 'scroll-timeline' : 'scroll-js');

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    var vh = window.innerHeight || 1;

    document.querySelectorAll('[data-scroll-3d="hero"]').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var progress = clamp(1 - (rect.top + rect.height * 0.35) / (vh + rect.height * 0.35), 0, 1);
      var tilt = (progress - 0.5) * 10;
      var z = progress * 24;
      var target = el.querySelector('.scroll-3d-tilt') || el.querySelector('.scroll-3d-img');
      if (target) {
        target.style.transform =
          'perspective(900px) rotateX(' + (tilt * 0.35).toFixed(2) + 'deg) rotateY(' + (tilt * -0.55).toFixed(2) + 'deg) translateZ(' + z.toFixed(1) + 'px)';
      }
    });

    document.querySelectorAll('[data-scroll-3d="section"]').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var mid = rect.top + rect.height * 0.2;
      var p = clamp(1 - mid / vh, 0, 1);
      var opacity = 0.35 + p * 0.65;
      var rise = (1 - p) * 28;
      var rot = (1 - p) * 4;
      el.style.opacity = String(opacity.toFixed(3));
      el.style.transform =
        'perspective(1000px) translateY(' + rise.toFixed(1) + 'px) rotateX(' + rot.toFixed(2) + 'deg) translateZ(0)';
    });

    document.querySelectorAll('[data-scroll-3d="card"]').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var mid = rect.top + rect.height * 0.5;
      var p = clamp(1 - mid / vh, 0, 1);
      var tiltY = (0.5 - p) * 8;
      var tiltX = (1 - p) * 3;
      el.style.transform =
        'perspective(800px) rotateY(' + tiltY.toFixed(2) + 'deg) rotateX(' + tiltX.toFixed(2) + 'deg) translateZ(' + (p * 8).toFixed(1) + 'px)';
    });
  }

  if (!supportsTimeline) {
    var ticking = false;
    function requestTick() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
      }
    }
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
    document.addEventListener('DOMContentLoaded', onScroll);
    onScroll();
  } else {
    // Still drive card tilts via JS (no CSS timeline preset for cards)
    var ticking2 = false;
    function requestTick2() {
      if (!ticking2) {
        ticking2 = true;
        requestAnimationFrame(function () {
          document.querySelectorAll('[data-scroll-3d="card"]').forEach(function (el) {
            var vh = window.innerHeight || 1;
            var rect = el.getBoundingClientRect();
            var mid = rect.top + rect.height * 0.5;
            var p = Math.max(0, Math.min(1, 1 - mid / vh));
            var tiltY = (0.5 - p) * 8;
            var tiltX = (1 - p) * 3;
            el.style.transform =
              'perspective(800px) rotateY(' + tiltY.toFixed(2) + 'deg) rotateX(' + tiltX.toFixed(2) + 'deg) translateZ(' + (p * 8).toFixed(1) + 'px)';
          });
          // Hero depth still useful when scroll() timeline unsupported for nested targets
          document.querySelectorAll('[data-scroll-3d="hero"]').forEach(function (el) {
            var vh = window.innerHeight || 1;
            var rect = el.getBoundingClientRect();
            var progress = Math.max(0, Math.min(1, 1 - (rect.top + rect.height * 0.35) / (vh + rect.height * 0.35)));
            var tilt = (progress - 0.5) * 10;
            var z = progress * 24;
            var target = el.querySelector('.scroll-3d-tilt') || el.querySelector('.scroll-3d-img');
            if (target && !document.documentElement.classList.contains('scroll-timeline')) {
              target.style.transform =
                'perspective(900px) rotateX(' + (tilt * 0.35).toFixed(2) + 'deg) rotateY(' + (tilt * -0.55).toFixed(2) + 'deg) translateZ(' + z.toFixed(1) + 'px)';
            }
          });
          ticking2 = false;
        });
      }
    }
    window.addEventListener('scroll', requestTick2, { passive: true });
    window.addEventListener('resize', requestTick2, { passive: true });
    document.addEventListener('DOMContentLoaded', requestTick2);
    requestTick2();
  }

  document.querySelectorAll('.sticky-buy-bar, .sticky-atc, [data-sticky-atc]').forEach(function (el) {
    el.classList.add('scroll-3d-exempt');
    el.style.transform = 'none';
    el.style.opacity = '1';
  });
})();
